// extracted by mini-css-extract-plugin
export default {"information-heading":"Titles_information-heading__Ph9TM","information-heading-text":"Titles_information-heading-text__12RY1"};